export function ActiveMarker({ color = 'currentColor' }: { color?: string }) {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill={color} xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_12564_32813" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="8" y="4" width="32" height="40">
        <path d="M40 4H8V44H40V4Z" fill="white" />
      </mask>
      <g mask="url(#mask0_12564_32813)">
        <path d="M24 44C23.46 44 22.94 43.78 22.56 43.4C21.06 41.86 8 28.14 8 19.9C8 11.14 15.18 4 24 4C32.82 4 40 11.14 40 19.9C40 28.14 26.92 41.86 25.44 43.4C25.06 43.78 24.54 44 24 44Z" fill="#FF1436" />
        <mask id="mask1_12564_32813" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="18" y="13" width="12" height="14">
          <path d="M30 13.333H18V26.6663H30V13.333Z" fill="white" />
        </mask>
        <g mask="url(#mask1_12564_32813)">
          <path d="M29.3333 26.6661H25.3333C24.9667 26.6661 24.6667 26.3661 24.6667 25.9994V22.6661H23.3333V25.9994C23.3333 26.3661 23.0333 26.6661 22.6667 26.6661H18.6667C18.3 26.6661 18 26.3661 18 25.9994V17.9994C18 17.7927 18.1 17.5927 18.2667 17.4661L23.6 13.4661C23.84 13.2861 24.16 13.2861 24.4 13.4661L29.7333 17.4661C29.9 17.5927 30 17.7927 30 17.9994V25.9994C30 26.3661 29.7 26.6661 29.3333 26.6661ZM26 25.3327H28.6667V18.3327L24 14.8327L19.3333 18.3327V25.3327H22V21.9994C22 21.6327 22.3 21.3327 22.6667 21.3327H25.3333C25.7 21.3327 26 21.6327 26 21.9994V25.3327Z" fill="white" />
        </g>
      </g>
    </svg>
  )
}
